import { render, staticRenderFns } from "./DistrictSelection.vue?vue&type=template&id=28fe60a0"
import script from "./DistrictSelection.vue?vue&type=script&lang=js"
export * from "./DistrictSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports